import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_secured/company-profile/import-hub/cross-platform',
)({
  beforeLoad() {
    throw redirect({ to: '/company-profile/import-hub/performance' });
  },
});
